import type { HandleClientError } from '@sveltejs/kit';

////////////////////////////////////////////////////////////////////////////
// These only need to load to work, no additional work is necessary
/* eslint-disable @typescript-eslint/no-unused-vars */
import { hotjarService } from '$lib/services/hotjar';
import { rollbarService } from '$lib/services/rollbar';
/* eslint-enable @typescript-eslint/no-unused-vars */
////////////////////////////////////////////////////////////////////////////

export const handleError: HandleClientError = ({ error, event, status, message }) => {
  rollbarService.instance?.error(error as Error, { event, status });
  return { message };
};
